import useSWR from 'swr'
import { getBuybackFee } from '~/apis'
import DataContainer from '~/components/DataContainer'
import { Trans, useTranslation } from 'react-i18next'
import { getSupportArticleLink } from '~/utils/common'
import { formatNumber } from '~/utils/numbers'
import { StyledIncomeContainer, StyledIncomeDataContainer } from './styled'

const IncomeExpensesArea: React.FC = () => {
  const { t, i18n } = useTranslation()
  const { data: buybackFee } = useSWR('getBuybackFee', getBuybackFee)
  const { historicalFeeUsd, currentFeeUsd, treasuryBalanceUsd } =
    buybackFee || {}
  const treasuryArticleLink = getSupportArticleLink(
    i18n.resolvedLanguage,
    '48512646670228',
  )

  return (
    <StyledIncomeContainer>
      <h4 className="title">{t('buyback_subtitle_balance')}</h4>
      <StyledIncomeDataContainer>
        <DataContainer
          dataTitle={t('buyback_card_history_fee')}
          description={`$${formatNumber(historicalFeeUsd, 2)}`}
          title={t('buyback_tips_history_fee')}
        />
        <DataContainer
          dataTitle={t('buyback_card_current_balance')}
          description={`$${formatNumber(currentFeeUsd, 2)}`}
          title={t('buyback_tips_current_balance')}
          className="charge-fee"
        />
        <DataContainer
          dataTitle={t('buyback_card_treasury')}
          description={`$${formatNumber(treasuryBalanceUsd, 2)}`}
          title={
            <Trans i18nKey="buyback_tips_treasury">
              <a href={treasuryArticleLink} target="_blank" rel="noreferrer">
                Tokenlon 社区财库余额
              </a>
              Tokenlon
              社区财库余额，因财库的代币价值会随着市场波动而变化，因此社区财库金额也会随之变化。
            </Trans>
          }
        />
      </StyledIncomeDataContainer>
    </StyledIncomeContainer>
  )
}

export default IncomeExpensesArea
